import { useEffect } from 'react';
import { useAppTheme } from 'contexts/ThemeContext'; // Adjust this path if needed

/**
 * A silent, logical component that sets the application's theme mode.
 * It renders nothing to the DOM.
 * @param {{ mode: 'preLogin' | 'postLogin' }} props
 */
const ThemeSetter = ({ mode }) => {
    // 1. Use our custom hook to get the function that changes the theme state.
    const { setThemeState } = useAppTheme();

    useEffect(() => {
        // 2. When this component is on the screen (i.e., when its parent layout is active),
        //    update the theme state to the mode specified in the props.
        setThemeState(prevState => ({
            ...prevState,
            mode: mode,
        }));
    }, [mode, setThemeState]); // This effect will re-run if the `mode` prop ever changes.

    // 3. This component has no visual output. It's purely for logic.
    return null;
};

export default ThemeSetter;